import React from "react";
import { Button, Callout, H6, H1 } from "@blueprintjs/core";
import { useParams } from "react-router-dom";
import { Trans } from "react-i18next";
import i18next from "i18next";
import i18n from '../../i18n';
import { getSetting } from "../Settings/InstallationSettings";

export function CertificateManager(props) {
    const { route } = useParams();
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
        console.info("This page is reloaded");
        window.location.replace("/home")
    }

    return (
        <div>
            <H1> <Trans>error</Trans> {route}</H1>
            <Callout intent="danger" title={i18n.t("certificate expired")}>

                <H6><Trans>the server can no longer be reached. this may be due to the fact that an SSL certificate used by our site has expired. this certificate guarantees that the information exchanged between your browser and our site remains confidential and secure. to accept the new certificate, please follow the procedure below:</Trans></H6>

                <ol>
                    <li><Trans>click on the following link to access the certificate acceptance page:</Trans>
                        <br />
                        <Button icon="link"
                            text={<Trans>link</Trans>}
                            onClick={() => route === "backend" ? window.open(window.config.backend.http_route)
                                : window.open('https://' + getSetting("phonie server IP", "") + ':' + getSetting("phonie wss port", "8089") + '/asterisk/ws')} />
                    </li>
                    <li><Trans>click on the 'advanced...' button :</Trans>
                        <br />
                        <img
                            src={i18next.language === "en" ? "/ow/view/pictures/certificate/en/advanced.png" : "/ow/view/pictures/certificate/fr/avance.png"}
                            alt="Adanced"
                        />
                    </li>
                    <li><Trans>then on 'accept the risk and continue':</Trans>
                        <br />
                        <img
                            src={i18next.language === "en" ? "/ow/view/pictures/certificate/en/accept.png" : "/ow/view/pictures/certificate/fr/accepter.png"}
                            alt="Accept"
                        />
                    </li>
                    <li><Trans>close the certificate acceptance page</Trans></li>
                    <li><Trans>return to home:</Trans>
                        <br />
                        <Button icon="home" text={<Trans>home</Trans>} onClick={() => window.location.replace("/ow/view/home")} />
                    </li>
                </ol>

            </Callout>
        </div>
    )

}